// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3-BH0","item":"PaymentsMobile_item__1VQhe","label":"PaymentsMobile_label__2vBjy","amount":"PaymentsMobile_amount__Dnacq"};